import type {Annotation} from "@/dungeons/model/DungeonGeometry.ts";

export const annotationKinds: {value: Annotation["kind"]; label: string; color: string; symbol: string}[] = [
    {value: "ROOM", label: "Raum", color: "#2563eb", symbol: "R"},
    {value: "NOTE", label: "Notiz", color: "#ca8a04", symbol: "N"},
    {value: "SECRET", label: "Geheimnis", color: "#9333ea", symbol: "G"},
    {value: "TRAP", label: "Falle / Gefahr", color: "#dc2626", symbol: "!"},
    {value: "OTHER", label: "Sonstiges", color: "#475569", symbol: "•"},
];

export function annotationAppearance(annotation: Annotation) {
    const kind = annotationKinds.find(candidate => candidate.value === annotation.kind) ?? annotationKinds[4];
    return {color: kind.color, label: (annotation.label?.trim() || kind.symbol).slice(0, 4)};
}
